import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default function Price({ product, priceInclVat, labels }) {
    const PriceAtom = ComponentRegistry.get("Price");

    return (
      <PriceAtom value={product.pricing[priceInclVat ? "incl" : "excl"]}
                 originalValue={product.originalPricing[priceInclVat ? "incl" : "excl"]}
                 vat={labels[priceInclVat ? "incl" : "excl"]}
      />
    );
}

Price.propTypes = {
    product: PropTypes.shape({
        pricing: PropTypes.shape({
            incl: PropTypes.string.isRequired,
            excl: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    labels: PropTypes.shape({
        incl: PropTypes.string.isRequired,
        excl: PropTypes.string.isRequired,
    }).isRequired,
    priceInclVat: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Atoms/Price.jsx